import { useTranslation } from 'react-i18next';
import { Card } from '@/components/common/Card';
import CardContent from '@/components/common/Card/CardContent';
import DetailItem from '@/components/common/DetailItem';
import type { GroupListItemDataFragment, SubgroupListItemDataFragment } from '@/gql/graphql';
import useDateFormats from '@/utils/useDateFormats';

interface DetailCardProps {
    group?: GroupListItemDataFragment;
    subgroup?: SubgroupListItemDataFragment;
}

const DetailCard = ({ group, subgroup }: DetailCardProps) => {
    const { t } = useTranslation('groups');
    const { formatDate } = useDateFormats();
    return (
        <div className="overflow-x-auto">
            <Card>
                <CardContent className="space-y-2 pt-0">
                    <DetailItem
                        label={t('detailCard.description')}
                        value={(subgroup ? subgroup.description : group?.description) || ''}
                    />
                    <div className="grid grid-cols-2 gap-4">
                        {subgroup && (
                            <>
                                <DetailItem label={t('detailCard.parentGroup')} value={group?.name || ''} />

                                <DetailItem
                                    label={t('detailCard.memberCount')}
                                    value={t('detailCard.users', {
                                        count: subgroup?.memberCount || 0,
                                    })}
                                />
                            </>
                        )}
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        <DetailItem
                            label={t('detailCard.createdAt')}
                            value={formatDate(subgroup ? subgroup.createdAt : group?.createdAt)}
                        />

                        <DetailItem
                            label={t('detailCard.updatedAt')}
                            value={formatDate(subgroup ? subgroup.updatedAt : group?.updatedAt)}
                        />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default DetailCard;
